//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import { RightsRequestMessageSource } from '@apis/rights-management/rightsManagementApiModels';
import Cuid from '@models/Cuid';
import CommunicationType from '@models/RightsCommunicationType';

import { Locales } from 'app/constants/locales/locale';

export interface RequestRightsOAuthParams {
  approvalPhrase: string;
  communicationType?: CommunicationType;
  cuid: Cuid;
  requestMessage: string;
  requestMessageLanguage?: Locales;
  requestMessageSource?: RightsRequestMessageSource;
  targetUrl: string;
}

export const getInstagramOauthUrl = (itemParams: RequestRightsOAuthParams) => {
  const itemParamString = encodeURIComponent(JSON.stringify(itemParams));
  const redirectUri = `${location.origin}/rights-request-oauth-landing`;

  const params = new URLSearchParams({
    client_id: CURALATE_ENV.INSTAGRAM_CLIENT_ID,
    redirect_uri: redirectUri,
    response_type: 'code',
    scope: 'user_profile',
    state: itemParamString,
  });

  return `https://api.instagram.com/oauth/authorize?${params.toString()}`;
};
